import { MouseEvent, ReactNode, useEffect, useState } from 'react'

import { RemoveCircle } from '@/components/Icons'
import cn from '@/utilities/cn'

import Tooltip from './Tooltip'

import './tooltip.scss'

type TooltipTriggerProps = {
  overlay?: ReactNode
  oversized?: boolean
  children: ReactNode
  desktopBreakpoint?: number
}

function TooltipTrigger({ overlay, oversized, children, desktopBreakpoint = 700 }: TooltipTriggerProps) {
  const [isVisible, setIsVisible] = useState(false)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    const listener = () => setWindowWidth(window.innerWidth)

    window.addEventListener('resize', listener)
    return () => window.removeEventListener('resize', listener)
  }, [])

  const showTooltip = (e?: MouseEvent) => {
    e && e.stopPropagation()

    setIsVisible(true)
  }

  const hideTooltip = (e?: MouseEvent) => {
    e && e.stopPropagation()

    setIsVisible(false)
  }

  /*
   * only hover events should trigger the tooltip on desktop platforms
   * only click events should trigger the tooltip on mobile platforms
   */
  const showTrigger = windowWidth > desktopBreakpoint ? 'onMouseEnter' : 'onClick'
  const hideTrigger = windowWidth > desktopBreakpoint ? 'onMouseLeave' : 'onClick'

  return (
    <div className="tooltip-overlay" {...{ [hideTrigger]: hideTooltip }}>
      <div className={cn('tooltip-trigger', 'visible')} {...{ [showTrigger]: showTooltip }}>
        {children}
      </div>

      {isVisible && (
        <Tooltip oversized={oversized}>
          <div className="tooltip-inner-wrapper">
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/anchor-is-valid */}
            <a className="tooltip-close" onClick={hideTooltip}>
              <RemoveCircle />
            </a>
            {overlay}
          </div>
        </Tooltip>
      )}
    </div>
  )
}

export default TooltipTrigger
